// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Y1H1","row":"ProcedureTreatmentSummary_row__1oQu4"};